import App from './App.jsx'
import ReactDOm from 'react-dom';
import React from 'react';

ReactDOm.render( 
    <App></App>,
    document.getElementById('root')
)